var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drop-zone-wrapper"},_vm._l((_vm.dropZones),function(zone){return _c('drop-zone',{key:zone.id,attrs:{"zone":zone}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }